import * as exConstants from './constants';
import type { TreeviewConfig, TreeviewConfigRequired } from './types';

import { slideDown, slideUp } from '../effect';

// ----------------------------------------------------------------------------

const DEFAULT_CONFIG: TreeviewConfigRequired = {
    accordion: true,
    animationSpeed: 300,
};

// ----------------------------------------------------------------------------

class TreeviewManager {
    private readonly element: HTMLElement;

    private readonly config: TreeviewConfigRequired;

    constructor(element: HTMLElement, config: TreeviewConfig = {}) {
        this.element = element;
        this.config = { ...DEFAULT_CONFIG, ...config };
    }

    open(): void {
        const event = new Event(exConstants.EVENT_EXPANDED);

        if (this.config.accordion) {
            const openMenuList = this.element.parentElement?.querySelectorAll(
                `${exConstants.SELECTOR_NAV_ITEM}.${exConstants.CLASS_NAME_MENU_OPEN}`,
            );

            openMenuList?.forEach((openMenu): any => {
                if (openMenu !== this.element.parentElement) {
                    openMenu.classList.remove(exConstants.CLASS_NAME_MENU_OPEN);

                    const childElement = openMenu.querySelector(exConstants.SELECTOR_TREEVIEW_MENU) as
                        | HTMLElement
                        | undefined;

                    if (childElement) {
                        slideUp(childElement, this.config.animationSpeed);
                    }
                }
            });
        }

        this.element.classList.add(exConstants.CLASS_NAME_MENU_OPEN);

        const childElement = this.element.querySelector(exConstants.SELECTOR_TREEVIEW_MENU) as HTMLElement | undefined;

        if (childElement) {
            slideDown(childElement, this.config.animationSpeed);
        }

        this.element.dispatchEvent(event);
    }

    close(): void {
        const event = new Event(exConstants.EVENT_COLLAPSED);

        this.element.classList.remove(exConstants.CLASS_NAME_MENU_OPEN);

        const childElement = this.element.querySelector(exConstants.SELECTOR_TREEVIEW_MENU) as HTMLElement | undefined;

        if (childElement) {
            slideUp(childElement, this.config.animationSpeed);
        }

        this.element.dispatchEvent(event);
    }

    toggle(): void {
        if (this.element.classList.contains(exConstants.CLASS_NAME_MENU_OPEN)) {
            this.close();
        } else {
            this.open();
        }
    }
}

// ----------------------------------------------------------------------------

export default TreeviewManager;
